document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.ugc-carousel').forEach((section) => {

    const track = section.querySelector('.ugc-carousel__track');
    const cards = section.querySelectorAll('.ugc-card');

    const prevBtn = section.querySelector('.ugc-carousel__arrow--prev');
    const nextBtn = section.querySelector('.ugc-carousel__arrow--next');

    if (!track || !cards.length) return;

    let currentIndex = 0;
    let autoplayInterval;

    const autoplay =
      section.dataset.autoplay === 'true';

    const autoplaySpeed =
      (parseInt(section.dataset.speed) || 4) * 1000;

    function getCardsPerView() {

      if (window.innerWidth < 768) {
        return 1;
      }

      if (window.innerWidth < 1025) {
        return 3;
      }

      return 5;
    }

    function getMaxIndex() {

      return Math.max(
        cards.length - getCardsPerView(),
        0
      );
    }

    function updateSlider() {

      const cardWidth =
        cards[0].offsetWidth + 20;

      track.style.transform =
        `translateX(-${currentIndex * cardWidth}px)`;
    }

    function nextSlide() {

      const maxIndex = getMaxIndex();

      if (currentIndex >= maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex++;
      }

      updateSlider();
    }

    function prevSlide() {

      const maxIndex = getMaxIndex();

      if (currentIndex <= 0) {
        currentIndex = maxIndex;
      } else {
        currentIndex--;
      }

      updateSlider();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }

    function startAutoplay() {

      if (!autoplay) return;

      clearInterval(autoplayInterval);

      autoplayInterval = setInterval(() => {

        nextSlide();

      }, autoplaySpeed);
    }

    function stopAutoplay() {

      clearInterval(autoplayInterval);
    }

    section.addEventListener(
      'mouseenter',
      stopAutoplay
    );

    section.addEventListener(
      'mouseleave',
      startAutoplay
    );

    /* MOBILE SWIPE */

    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener('touchstart', (e) => {

      touchStartX = e.changedTouches[0].clientX;

    });

    track.addEventListener('touchend', (e) => {

      touchEndX = e.changedTouches[0].clientX;

      const diff =
        touchStartX - touchEndX;

      if (diff > 50) {
        nextSlide();
      }

      if (diff < -50) {
        prevSlide();
      }

    });

    /* VIDEO PLAY */

    section.querySelectorAll('.ugc-card').forEach((card) => {

      const video =
        card.querySelector('video');

      const playBtn =
        card.querySelector('.ugc-card__play');

      if (!video || !playBtn) return;

      playBtn.addEventListener('click', () => {

        section
          .querySelectorAll('video')
          .forEach((v) => {

            if (v !== video) {

              v.pause();

              const btn =
                v.closest('.ugc-card')
                ?.querySelector('.ugc-card__play');

              if (btn) {
                btn.style.display = '';
              }
            }

          });

        if (video.paused) {

          video.play();

          playBtn.style.display = 'none';

        } else {

          video.pause();

          playBtn.style.display = '';

        }

      });

      video.addEventListener('pause', () => {

        playBtn.style.display = '';

      });

    });

    window.addEventListener(
      'resize',
      updateSlider
    );

    updateSlider();
    startAutoplay();

  });

});